
  import {
    Component,
    Model,
    Prop,
    Vue
  } from "vue-property-decorator";

  @Component({
    name: 'slz-switch',
  })
  export default class SlzSwitch extends Vue {
    @Prop({default: '开'}) private activeText!: string;
    @Prop({default: '关'}) private hideText!: string;
    @Prop({default: ''}) private disabled!: boolean | number; 
    @Prop({default: '已禁用'}) private disabledTips!: string;
    @Prop() iswatch!: boolean;
    @Model('change') isShow!: boolean;

    // 点击修改
    private handleClick() {
      if(this.iswatch){
        return
      }
      // console.log('switch component disabled===>', this.disabled)
      if (this.disabled) {
        this.$message({
          type: 'warning',
          message: this.disabledTips
        })
        return
      }
      this.$emit('change', !this.isShow);
    }
  }
